<template>
  <NavigationLinkButton
    :icon="Icon.LOG"
    :title="$t('pages.apiRequestLog.title')"
    :subtitle="$t('pages.apiRequestLog.subtitle')"
    :to="apiRequestLogRoute"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Icon } from "../../assets/icons/Icon";
import NavigationLinkButton from "../../components/NavigationLinkButton.vue";

const props = defineProps<{
  clientAppId: number;
}>();

const apiRequestLogRoute = computed(() => ({
  name: "apiRequestLogList",
  query: {
    clientAppId: props.clientAppId,
  },
}));
</script>
